let openPaymentAddConfig = {};

export function setOpenPaymentAddConfig(config) {
    openPaymentAddConfig = config || {};
}

export function getOpenPaymentAddConfig() {
    return openPaymentAddConfig;
}

export function opCfg() {
    return openPaymentAddConfig;
}

export function opIsMemberSession() {
    return !!opCfg().isMemberSession;
}

export function opMemberUserId() {
    const configured = opCfg().openPaymentMemberUserId;
    if (configured != null && configured !== '') {
        return String(configured);
    }
    if (opIsMemberSession()) {
        const authId = opCfg().authUserId;
        if (authId != null && authId !== '') {
            return String(authId);
        }
    }
    return null;
}

export function opHasPrefilledMember() {
    return !!opCfg().memberOpenPayment || (opIsMemberSession() && !!opMemberUserId());
}

export function opMinAmount() {
    return Number(opCfg().minAmount || 0);
}

export function opGatewayApiForId(gatewayId) {
    const mapped = (opCfg().gatewayApisById || {})[String(gatewayId)];
    return mapped ? String(mapped) : '';
}

export function formatPaymentDate(date) {
    const d = date || new Date();
    return (d.getMonth() + 1).toString().padStart(2, '0') + '/' +
        d.getDate().toString().padStart(2, '0') + '/' + d.getFullYear();
}
